import * as React from "react";
import { useNavigate } from "react-router-dom";

function GetInTouchButton() {
  const navigate = useNavigate();
  
  return (
    <button 
      onClick={() => navigate("/contact")}
      className="px-8 py-3.5 text-base font-semibold text-teal-500 bg-white rounded transition-all ease-in-out cursor-pointer border-[nonepx] duration shadow-[0_2px_4px_rgba(0,0,0,0.1)]">
        Get In Touch
    </button>
  );
}

export default GetInTouchButton;
